import { Grid, Fab, Typography, FormHelperText, Select, Box} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Field, FieldArray, useFormikContext } from "formik";
//5889
import { TextField } from "formik-mui";
import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconButton from "@mui/material/IconButton";
import { TextField as UiTextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import propTypes from "prop-types";
import MoreInfo from "./MoreInfo";

const PREFIX = "DynamicFieldArray";

const classes = {
  fab: `${PREFIX}-fab`,
  extendedIcon: `${PREFIX}-extendedIcon`,
  iconButton: `${PREFIX}-iconButton`,
  webPageURL: `${PREFIX}-webPageURL`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.fab}`]: {
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.extendedIcon}`]: {
    marginRight: theme.spacing(1),
  },

  [`& .${classes.iconButton}`]: {
    position: "relative",
    right: theme.spacing(1),
  },

  [`& .${classes.webPageURL}`]: {
    marginTop: "40px",
  },
}));

const cache_page = {
  cachepage_url: "",
  stim_list: [
    {
      stim_url: "",
      brand_id: null,
      ad_type_id: "",
    },
  ],
};
const stim = { stim_url: "", brand_id: null, ad_type_id: "" };

const isStimComplete = (stim) =>
  stim.stim_url && stim.brand_id && stim.ad_type_id;
function StimAndBrand({ adTypes, brandTypes, number, stimOnly }) {
  const { values, isSubmitting, setFieldValue } = useFormikContext();

  const stimList = values.cachepage_stim_list[number].stim_list;

  const isLastStim = (index) => {
    return index + 1 === stimList.length;
  };

  const isStimComplete = (stim) =>
    stim?.stim_url && stim?.brand_id && stim?.ad_type_id;

  function validateEmptyStims(value) {
    return !value ? "Required" : undefined;
  }

  function validateFirstStim(value) {
    return !value ? "At least 1 stim required" : undefined;
  }

  const handleAutoComplete = (value, name) => {
    setFieldValue(name, value);
  };

  const handleSelect = (e) => {
    setFieldValue(e.target.name, e.target.value);
  };

  const globalStimOffset = values.cachepage_stim_list
    .slice(0, number)
    .reduce((acc, item) => acc + item.stim_list.length, 0);

  useEffect(() => {
    if (!Array.isArray(stimList) || stimList.length === 0) return;

    const lastStim = stimList[stimList.length - 1];
    const alreadyHasEmptyRow = !isStimComplete(lastStim);

    if (!alreadyHasEmptyRow) {
      const updated = [...stimList, { stim_url: "", brand_id: null, ad_type_id: "" }];
      const newValues = [...values.cachepage_stim_list];
      newValues[number].stim_list = updated;
      setFieldValue("cachepage_stim_list", newValues);
    }
  }, [stimList.length]);

  return (
    <Root>
      <FieldArray name={`cachepage_stim_list[${number}].stim_list`}>
        {({ remove }) => (
          <>
            {stimOnly ? (
              <Box
                key={`stimOnly-${number}`}
                display="flex"
                flexDirection="column"
                width="100%"
                gap={3}
                mt={2}
              >
                {stimList.map((_, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: '100%',
                      mt: 2,
                      display: 'block',
                    }}
                  >
                    <Typography variant="subtitle2" gutterBottom>
                      Cell {globalStimOffset + index + 1}:
                    </Typography>
                    <Field
                      size="medium"
                      variant="filled"
                      fullWidth
                      name={`cachepage_stim_list.${number}.stim_list.${index}.stim_url`}
                      component={TextField}
                      validate={
                        index === 0
                          ? validateFirstStim
                          : isLastStim(index)
                          ? ""
                          : validateEmptyStims
                      }
                      label="Stim URL"
                    />
                  </Box>
                ))}
              </Box>
            ) : (
              stimList.map((_, index) => (
                <Box
                  key={index}
                  display="flex"
                  gap={2}
                  width="100%"
                  alignItems="flex-start"
                  justifyContent="flex-end"
                  ml="auto"
                >
                  <Box flex="0 0 auto">
                    {isLastStim(index) ? null : (
                      <IconButton
                        className={classes.iconButton}
                        disabled={isSubmitting}
                        onClick={() => remove(index)}
                        size="large"
                      >
                        <HighlightOffIcon color="primary" />
                      </IconButton>
                    )}
                  </Box>

                  <Box flex="1" minWidth={120}>
                    <Field
                      size="small"
                      variant="filled"
                      fullWidth
                      name={`cachepage_stim_list.${number}.stim_list.${index}.stim_url`}
                      component={TextField}
                      validate={
                        index === 0
                          ? validateFirstStim
                          : isLastStim(index)
                          ? ""
                          : validateEmptyStims
                      }
                      label="Stim URL"
                    />
                  </Box>

                  <Box flex="1" minWidth={120}>
                    <Field
                      name={`cachepage_stim_list.${number}.stim_list.${index}.brand_id`}
                      validate={
                        index === 0
                          ? validateFirstStim
                          : isLastStim(index)
                          ? ""
                          : validateEmptyStims
                      }
                    >
                      {({ field, meta }) => (
                        <Autocomplete
                          {...field}
                          size="small"
                          fullWidth
                          onChange={(e, value) =>
                            handleAutoComplete(
                              value?.id || null,
                              `cachepage_stim_list.${number}.stim_list.${index}.brand_id`
                            )
                          }
                          value={
                            brandTypes.data.find((b) => b.id === field.value) || null
                          }
                          options={brandTypes.data}
                          getOptionLabel={(option) => option.name}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          renderInput={(params) => (
  <UiTextField
    error={meta.touched && Boolean(meta.error)}
    {...params}
    label="Brand"
    variant="filled"
    helperText={meta.touched && meta.error}
    sx={{
      "& .MuiFilledInput-root": {
        backgroundColor: "rgba(0, 0, 0, 0.06)", 
       
      },
      "& .MuiFilledInput-input": {
        backgroundColor: "transparent",
        boxShadow: "none"
      },
    }}
  />
)}


                        />
                      )}
                    </Field>
                  </Box>

                  <Box flex="1" minWidth={120}>
                    <Field
                      name={`cachepage_stim_list.${number}.stim_list.${index}.ad_type_id`}
                      validate={
                        index === 0
                          ? validateFirstStim
                          : isLastStim(index)
                          ? ""
                          : validateEmptyStims
                      }
                    >
                      {({ field, meta }) => (
                        <FormControl
                          error={meta.touched && Boolean(meta.error)}
                          size="small"
                          variant="filled"
                          fullWidth
                        >
                          <InputLabel>Ad format</InputLabel>
                          <Select
                            {...field}
                            value={field.value || ""}
                            onChange={(e) => handleSelect(e)}
                          >
                            {adTypes.data.map((ad) => (
                              <MenuItem key={ad.id} value={ad.id}>
                                {ad.name}
                              </MenuItem>
                            ))}
                          </Select>
                          {meta.touched && Boolean(meta.error) && (
                            <FormHelperText>{meta.error}</FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </Field>
                  </Box>
                </Box>
              ))
            )}
          </>
        )}
      </FieldArray>
    </Root>
  );
}



StimAndBrand.propTypes = {
  brandTypes: propTypes.object,
  adTypes: propTypes.object,
  number: propTypes.number,
  stimOnly: propTypes.bool,
};

export default function DynamicFieldArray({ adTypes, brandTypes, stimOnly }) {
  const { values, errors, isSubmitting, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (!stimOnly) return;
  
    const currentLength = values.cachepage_stim_list.length;
    const targetLength = values.number_of_cells || 0;
  
    if (currentLength < targetLength) {
      const itemsToAdd = Array.from({ length: targetLength - currentLength }, () => ({
        cachepage_url: "",
        stim_list: [{ stim_url: "", brand_id: null, ad_type_id: "" }],
      }));
      setFieldValue("cachepage_stim_list", [...values.cachepage_stim_list, ...itemsToAdd]);
    } else if (currentLength > targetLength) {
      setFieldValue("cachepage_stim_list", values.cachepage_stim_list.slice(0, targetLength));
    }
  }, [values.number_of_cells, stimOnly]);
  
  return (
    <>
      <FieldArray name="cachepage_stim_list">
        {({ push, remove }) => (
          <React.Fragment>
            <Grid
              alignContent="flex-end"
              container
              wrap="nowrap"
              justifyContent="space-between"
              item
              xs={12}
            >
              <Grid>
                <Typography variant="h6" >

{stimOnly? "Video Setup": "Web Page Setup"}            
    </Typography>
                <Typography variant="subtitle1" >
                  Please enter the URL of the live web page you want to test
                  your ads on, together with your ad details.
                </Typography>
              </Grid>
              <MoreInfo
                outerContainerClassName="cacheSetup"
                popupArray={[
                  "Live web page URL: The live web page is where your add will be displayed.",
                  "Stim URL: A link to a webpage which features only your test.",
                  "Ad Brand: The brand name of the company featured in your test ad.",
                  "Ad format: The format your test ad will be displayed as.",
                ]}
              />
            </Grid>
            {values.cachepage_stim_list.map((_, index) => (
              <React.Fragment key={index}>

                {!stimOnly && (
  <>
                <Grid item className={classes.webPageURL} xs={1}>
                  {index === 0 ? (
                    ""
                  ) : (
                    <IconButton
                      className={classes.iconButton}
                      disabled={isSubmitting}
                      onClick={() => remove(index)}
                      size="large"
                    >
                      <HighlightOffIcon color="primary" />
                    </IconButton>
                  )}
                </Grid>


                <Grid
                  className={classes.webPageURL}
                  alignItems="center"
                  container
                  wrap="nowrap"
                  item
                  xs={11}
                  style={{ marginBottom: "24px" }}

                >
                  <Typography
                    style={{ marginRight: "8px" }}
                    variant="body1"
                    component={"span"}
                  >{`${index + 1}.`}</Typography>
                  <Field
                    variant="filled"
                    fullWidth
                    name={`cachepage_stim_list.${index}.cachepage_url`}
                    component={TextField}
                    label="Live web page URL"
                  />
                </Grid>
                </>
)}


                <StimAndBrand adTypes={adTypes} brandTypes={brandTypes} number={index} stimOnly={stimOnly} />
                </React.Fragment>
            ))}

            <Grid item>
              {typeof errors.cachepage_stim_list === "string" ? (
                <Typography color="error" component={"span"}>
                  {errors.cachepage_stim_list}
                </Typography>
              ) : null}
            </Grid>

            <Grid
              className={classes.fab}
              container
              justifyContent="center"
              item
              xs={12}
            >
              <Grid item>
              {!stimOnly && (
               <Fab
  variant="extended"
  size="medium"
  className="button-primary"
  aria-label="add"
  disabled={isSubmitting}
  onClick={() => push(cache_page)}
  type="button"
>
  <AddIcon className={classes.extendedIcon} />
  Add web page
</Fab>

                )}
              </Grid>
            </Grid>
          </React.Fragment>
        )}
      </FieldArray>
    </>
  );
}
